import type { JSResourceOptions, Loader, PreloadableJSResourceReference } from '../../types';
import { createCache } from '../../utils';
import { PreloadableJSResource } from '../preloadable-js-resource';
import { postTask } from '../scheduler';

const cache = createCache(new Map<string, PreloadableJSResourceReference<any>>());

export function JSResourceForInteraction<T>(
	loader: Loader<T>,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T> {
	return cache.get(opts!.moduleId!, () =>
		PreloadableJSResource(() => postTask(loader, { priority: 'user-visible' }), opts!),
	);
}
